"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const CutSideButton_1 = __importStar(require("../../atoms/CutSideButton"));
const bridge_1 = require("@completeanatomy/bridge");
const providers_1 = require("../../providers");
const hooks_1 = require("../../hooks");
const ui_1 = require("@completeanatomy/ui");
const ui_2 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const drawStyle = {
    lineWidth: 2,
    lineDash: [4, 8],
    startCircleRadius: 50,
    startCircleWidth: 1,
    endCircleRadius: 30,
    endCircleWidth: 2,
};
// eslint-disable-next-line max-lines-per-function
function ToolsCutLines({ width = 0, height = 0, color = '', strokeColor = '', selectedType, subtype, }) {
    const [isDrawing, setDrawing] = (0, react_1.useState)(false);
    const [startPoint, setStartPoint] = (0, react_1.useState)();
    const [endPoint, setEndPoint] = (0, react_1.useState)();
    const [lines, setLines] = (0, react_1.useState)([]);
    const [isScissorsVisible, setScissorsVisible] = (0, react_1.useState)(false);
    const [, dispatch] = (0, providers_1.useToolsModeContext)();
    const bridge = (0, bridge_1.useBridge)();
    const canvasRef = (0, react_1.useRef)(null);
    const currentType = (0, react_1.useRef)(subtype);
    const isRightButton = (0, react_1.useRef)(false);
    const optimalScaleFactor = (0, device_1.useOptimalScreenScale)();
    const deviceScaleFactor = window.devicePixelRatio / (optimalScaleFactor || window.devicePixelRatio);
    const [pointers, updatePointer, removePointer] = (0, ui_1.usePointers)();
    const formatPoint = (point) => {
        return `{${point.x}, ${point.y}}`;
    };
    const getSideString = (side) => {
        return side === CutSideButton_1.ToolsCutSide.Left ? 'left' : 'right';
    };
    const calcLineForNative = (0, react_1.useCallback)((line) => {
        return {
            from: (0, ui_2.multiplyPoint)(line.from, deviceScaleFactor),
            to: (0, ui_2.multiplyPoint)(line.to, deviceScaleFactor),
        };
    }, [deviceScaleFactor]);
    const onCut = (0, react_1.useCallback)((side) => {
        setScissorsVisible(false);
        setLines([]);
        dispatch((0, hooks_1.toggleCutLineDrawn)(false));
        if (subtype === bridge_schema_1.ToolType.Cut1Side) {
            const line = lines[0];
            const angle = (0, ui_2.angleBetweenPointsDeg)(line.from, line.to);
            bridge === null || bridge === void 0 ? void 0 : bridge.cutModelByLine({
                action: bridge_schema_1.CutModelAction.Cut,
                side,
                line: calcLineForNative(lines[0]),
            });
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                type: bridge_schema_1.ToolType.Cut1Side,
                currentOptions: {
                    type: bridge_schema_1.ToolType.Cut1Side,
                    cutMode: selectedType,
                    lineIsDrawn: true,
                },
                cutInfo: {
                    side: getSideString(side),
                    action: 'cut',
                    line1: {
                        startPoint: formatPoint(line.from),
                        endPoint: formatPoint(line.to),
                    },
                    angle: angle,
                },
                optionType: 10,
                record: false,
            });
        }
        if (subtype === bridge_schema_1.ToolType.CutBetween) {
            const line1 = lines[0];
            const line2 = lines[1];
            bridge === null || bridge === void 0 ? void 0 : bridge.cutModelBetween({
                action: bridge_schema_1.CutModelAction.Cut,
                isLineDrawn: true,
                line1: calcLineForNative(line1),
                line2: calcLineForNative(line2),
            });
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                type: bridge_schema_1.ToolType.CutBetween,
                currentOptions: {
                    type: bridge_schema_1.ToolType.CutBetween,
                    cutMode: selectedType,
                    lineIsDrawn: true,
                },
                cutInfo: {
                    action: 'cut',
                    line1: {
                        startPoint: formatPoint(line1.from),
                        endPoint: formatPoint(line1.to),
                    },
                    line2: {
                        startPoint: formatPoint(line2.from),
                        endPoint: formatPoint(line2.to),
                    },
                },
                optionType: 10,
                record: false,
            });
        }
    }, [lines, subtype, selectedType, dispatch, bridge, calcLineForNative]);
    const onPaintStartHandler = (0, react_1.useCallback)((event) => {
        // prevent when clicking on buttons
        if ((event.target && event.target.tagName === 'BUTTON') ||
            event.target.closest('button')) {
            return;
        }
        updatePointer(event);
        if ((0, ui_1.isMultiTouch)(event, pointers.current) ||
            selectedType === bridge_schema_1.ToolType.None) {
            return;
        }
        isRightButton.current = false;
        // disable any action on right mouse button
        if ((0, ui_2.isRightMouseButton)(event)) {
            isRightButton.current = true;
            event.stopPropagation();
            return;
        }
        if (subtype === bridge_schema_1.ToolType.Cut1Side) {
            setLines([]);
            setScissorsVisible(false);
            dispatch((0, hooks_1.toggleCutLineDrawn)(false));
            bridge === null || bridge === void 0 ? void 0 : bridge.cutModelByLine({ action: bridge_schema_1.CutModelAction.Move });
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                type: bridge_schema_1.ToolType.Cut1Side,
                currentOptions: {
                    type: bridge_schema_1.ToolType.Cut1Side,
                    cutMode: selectedType,
                    lineIsDrawn: false,
                },
                optionType: 10,
                record: true,
                cutInfo: { action: 'move' },
            });
            bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
                type: bridge_schema_1.ToolType.Cut1Side,
                currentOptions: {
                    type: bridge_schema_1.ToolType.Cut1Side,
                    cutMode: selectedType,
                    lineIsDrawn: false,
                },
            });
        }
        if (subtype === bridge_schema_1.ToolType.CutBetween) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                type: bridge_schema_1.ToolType.CutBetween,
                currentOptions: {
                    type: bridge_schema_1.ToolType.CutBetween,
                    cutMode: selectedType,
                    lineIsDrawn: false,
                },
                optionType: 10,
                record: true,
                cutInfo: { action: 'move' },
            });
            bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
                type: bridge_schema_1.ToolType.CutBetween,
                currentOptions: {
                    type: bridge_schema_1.ToolType.CutBetween,
                    cutMode: selectedType,
                    lineIsDrawn: false,
                },
            });
        }
        const point = (0, ui_2.getPosition)(event);
        setStartPoint(point);
        setEndPoint(undefined);
        setDrawing(true);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [subtype, selectedType]);
    const onPaintHandler = (0, react_1.useCallback)((event) => {
        // prevent when clicking on buttons
        if ((event.target && event.target.tagName === 'BUTTON') ||
            event.target.closest('button')) {
            return;
        }
        updatePointer(event);
        if ((0, ui_1.isMultiTouch)(event, pointers.current) && isDrawing) {
            setDrawing(false);
            return;
        }
        if (isRightButton.current) {
            event.stopPropagation();
            return;
        }
        if (isDrawing) {
            const point = (0, ui_2.getPosition)(event);
            setEndPoint(point);
            const line = {
                from: startPoint || { x: 0, y: 0 },
                to: point,
            };
            if (subtype === bridge_schema_1.ToolType.Cut1Side) {
                bridge === null || bridge === void 0 ? void 0 : bridge.cutModelByLine({
                    action: bridge_schema_1.CutModelAction.Move,
                    line: calcLineForNative(line),
                });
                bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                    type: bridge_schema_1.ToolType.Cut1Side,
                    currentOptions: {
                        type: bridge_schema_1.ToolType.Cut1Side,
                        cutMode: selectedType,
                        lineIsDrawn: true,
                    },
                    optionType: 10,
                    record: true,
                    cutInfo: {
                        line1: {
                            startPoint: formatPoint(line.from),
                            endPoint: formatPoint(line.to),
                        },
                        action: 'move',
                    },
                });
            }
            if (subtype === bridge_schema_1.ToolType.CutBetween) {
                const isLineDrawn = lines.length === 1;
                const currentLine = calcLineForNative(line);
                bridge === null || bridge === void 0 ? void 0 : bridge.cutModelBetween({
                    action: bridge_schema_1.CutModelAction.Move,
                    isLineDrawn: isLineDrawn,
                    line1: isLineDrawn ? undefined : currentLine,
                    line2: isLineDrawn ? currentLine : undefined,
                });
                bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                    type: bridge_schema_1.ToolType.CutBetween,
                    currentOptions: {
                        type: bridge_schema_1.ToolType.CutBetween,
                        cutMode: selectedType,
                        lineIsDrawn: isLineDrawn,
                    },
                    optionType: 10,
                    record: true,
                    cutInfo: {
                        line1: {
                            startPoint: formatPoint(line.from),
                            endPoint: formatPoint(line.to),
                        },
                        action: 'move',
                    },
                });
                bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                    type: bridge_schema_1.ToolType.CutBetween,
                    currentOptions: {
                        type: bridge_schema_1.ToolType.CutBetween,
                        cutMode: selectedType,
                        lineIsDrawn: isLineDrawn,
                    },
                    optionType: 10,
                    record: true,
                    cutInfo: {
                        line2: {
                            startPoint: formatPoint(line.from),
                            endPoint: formatPoint(line.to),
                        },
                        action: 'move',
                    },
                });
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isDrawing, startPoint, subtype, lines, deviceScaleFactor]);
    const onPaintEndHandler = (0, react_1.useCallback)((event) => {
        // prevent when clicking on buttons
        if ((event.target && event.target.tagName === 'BUTTON') ||
            event.target.closest('button')) {
            return;
        }
        removePointer(event);
        if (!isDrawing) {
            return;
        }
        setDrawing(false);
        if (startPoint && endPoint) {
            const line = { from: startPoint, to: endPoint };
            lines.push(line);
            setLines([...lines]);
            if (subtype === bridge_schema_1.ToolType.Cut1Side && lines.length === 1) {
                setScissorsVisible(true);
                dispatch((0, hooks_1.toggleCutLineDrawn)(true));
            }
            if (subtype === bridge_schema_1.ToolType.CutBetween) {
                lines.length > 1 && onCut(CutSideButton_1.ToolsCutSide.Right);
                lines.length === 1 && dispatch((0, hooks_1.toggleCutLineDrawn)(true));
            }
            if (subtype === bridge_schema_1.ToolType.CutBetween && lines.length > 1) {
                setLines([]);
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isDrawing, startPoint, endPoint, lines, subtype]);
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return;
        }
        const events = (0, ui_2.getPointersEvents)();
        document.addEventListener(events.down, onPaintStartHandler);
        document.addEventListener(events.move, onPaintHandler, true);
        document.addEventListener(events.up, onPaintEndHandler);
        return () => {
            document.removeEventListener(events.down, onPaintStartHandler);
            document.removeEventListener(events.move, onPaintHandler, true);
            document.removeEventListener(events.up, onPaintEndHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onPaintStartHandler, onPaintHandler, onPaintEndHandler]);
    const drawAimCircle = (0, react_1.useCallback)((context, point) => {
        context.beginPath();
        context.lineWidth = drawStyle.startCircleWidth;
        context.strokeStyle = color;
        context.setLineDash([]);
        context.arc(point.x, point.y, drawStyle.startCircleRadius, 0, 2 * Math.PI, false);
        context.stroke();
        context.closePath();
        context.beginPath();
        const radius = drawStyle.startCircleRadius;
        let x = point.x - radius - 5;
        let y = point.y;
        context.moveTo(x, y);
        context.lineTo(x + 10, y);
        x = point.x + radius - 5;
        context.moveTo(x, y);
        context.lineTo(x + 10, y);
        context.stroke();
        context.closePath();
        context.beginPath();
        x = point.x;
        y = point.y + radius - 5;
        context.moveTo(x, y);
        context.lineTo(x, y + 10);
        context.stroke();
        context.closePath();
        context.beginPath();
        y = point.y - radius - 5;
        context.moveTo(x, y);
        context.lineTo(x, y + 10);
        context.stroke();
        context.closePath();
    }, [color]);
    const drawFingerCircle = (0, react_1.useCallback)((context, point) => {
        context.beginPath();
        context.lineWidth = drawStyle.endCircleWidth;
        context.strokeStyle = color;
        context.setLineDash([]);
        context.arc(point.x, point.y, drawStyle.endCircleRadius, 0, 2 * Math.PI, false);
        context.stroke();
        context.closePath();
        context.beginPath();
        context.strokeStyle = strokeColor;
        context.arc(point.x, point.y, drawStyle.endCircleRadius - drawStyle.endCircleWidth, 0, 2 * Math.PI, false);
        context.stroke();
        context.closePath();
    }, [color, strokeColor]);
    const drawLine = (0, react_1.useCallback)((context, from, to) => {
        context.lineJoin = 'miter';
        context.lineCap = 'square';
        context.beginPath();
        context.lineWidth = drawStyle.lineWidth;
        context.strokeStyle = color;
        context.setLineDash([]);
        context.moveTo(from.x, from.y);
        context.lineTo(to.x, to.y);
        context.stroke();
        context.closePath();
        context.strokeStyle = strokeColor;
        context.setLineDash(drawStyle.lineDash);
        context.moveTo(from.x, from.y);
        context.lineTo(to.x, to.y);
        context.stroke();
        context.closePath();
        context.fillStyle = color;
        context.setLineDash([]);
        context.beginPath();
        context.arc(from.x, from.y, 3, 0, 2 * Math.PI, false);
        context.fill();
        context.closePath();
        context.beginPath();
        context.arc(to.x, to.y, 3, 0, 2 * Math.PI, false);
        context.fill();
        context.closePath();
    }, [color, strokeColor]);
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return;
        }
        const context = canvasRef.current.getContext('2d');
        if (!context) {
            return;
        }
        context.clearRect(0, 0, width, height);
        lines.forEach((line) => {
            drawLine(context, line.from, line.to);
        });
        if (isDrawing) {
            if (startPoint && endPoint) {
                drawLine(context, startPoint, endPoint);
            }
            if (startPoint) {
                drawAimCircle(context, startPoint);
            }
            if (endPoint) {
                drawFingerCircle(context, endPoint);
            }
        }
    }, [
        width,
        height,
        color,
        strokeColor,
        startPoint,
        endPoint,
        isDrawing,
        lines,
        drawAimCircle,
        drawFingerCircle,
        drawLine,
    ]);
    (0, react_1.useEffect)(() => {
        if (currentType.current != subtype) {
            setLines([]);
            setScissorsVisible(false);
            dispatch((0, hooks_1.toggleCutLineDrawn)(false));
            currentType.current = subtype;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subtype]);
    let angle = 0;
    let direction = CutSideButton_1.ToolsCutDirection.Right;
    if (startPoint && endPoint) {
        angle = (0, ui_2.angleBetweenPointsDeg)(startPoint, endPoint);
        direction =
            startPoint.x < endPoint.x
                ? CutSideButton_1.ToolsCutDirection.Right
                : CutSideButton_1.ToolsCutDirection.Left;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Canvas, { ref: canvasRef, width: width, height: height, role: "dialog", "data-testid": "tools-dialog", "data-e2e": 'ToolsCutLines_Canvas' }), isScissorsVisible && ((0, jsx_runtime_1.jsx)(CutSideButton_1.default, { position: endPoint, angle: angle, direction: direction, onCut: onCut, "data-e2e": 'ToolsCutLines_ToolsCutSideButton' }))] }));
}
exports.default = ToolsCutLines;
const Canvas = styled_components_1.default.canvas `
  position: absolute;
  top: 0;
  left: 0;

  user-select: none;
  pointer-events: none;
`;
